import { render } from "./vdvcorderranking.vue?vue&type=template&id=118bc7f5&scoped=true"
import script from "./vdvcorderranking.vue?vue&type=script&lang=js"
export * from "./vdvcorderranking.vue?vue&type=script&lang=js"

import "./vdvcorderranking.vue?vue&type=style&index=0&id=118bc7f5&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境商户后台shop.jsyinba.com/jsmerchant/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-118bc7f5"]])

export default __exports__